import config from 'config'

if (config.env === 'dev' && config.basicAuth && typeof window !== 'undefined') {
  const basicAuth = config.basicAuth
  const originalFetch = window.fetch

  window.fetch = async (...args) => {
    const [url, options] = args
    if (url.toString().startsWith('http')) return originalFetch(...args)
    const newUrl = location.origin + url.toString()
    return originalFetch(newUrl, {
      ...options,
      headers: {
        ...options?.headers,
        Authorization: `Basic ${btoa(basicAuth)}`
      }
    })
  }
}
